import React, { Component } from 'react'
import LogoItem from './logo/LogoItem'
import { DropDownNav, ProfileItem } from './NavigationComponents'
import { dispatcher } from './NavigationDispatcher'
import PrimaryDropDown from './lists/PrimaryDropDown'
import Constants from 'scripts/base/Constants'
import { ExplorePaths } from 'scripts/config/ExplorePaths'
import SearchLink from 'scripts/components/search/SearchLink'
import { toggleDarkModeAndRender, isMobile } from 'scripts/lib/utils'
import User from 'scripts/lib/firebase/user'
import {getLang, langPrefix} from 'shared/i18n/react'
import NavInlineSearch from 'scripts/components/search/NavInlineSearch'

export const SCROLL_THRESHOLD = 600
class Navigation extends Component {
  constructor(props) {
    super(props)
    this.menubarClick = this.menubarClick.bind(this)
    this.state = { change: false, style: '' }
    this.currentActive = null
    this.updateActive = this.updateActive.bind(this)
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.setExcludedWrapperRef = this.setExcludedWrapperRef.bind(this)
    this.excludedWrapperRefContains = this.excludedWrapperRefContains.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.lang = getLang()
    this.langPrefix = langPrefix()
  }

  componentDidMount() {
    dispatcher.on(Constants.Navigations.STORE_ACTIVE_NAV, this.updateActive)
    document.addEventListener('mouseup', this.handleClickOutside)
  }

  componentWillUnmount() {
    dispatcher.off(Constants.Navigations.STORE_ACTIVE_NAV, this.updateActive)
    document.removeEventListener('mouseup', this.handleClickOutside)
  }

  updateActive(data) {
    this.currentActive = data.id
    this.updateBodyClass(data.id)
  }

  updateBodyClass(id) {
    const body = document.body

    if (id && !body.classList.contains('navbar-open')) {
      body.classList.add('navbar-open')
    } else if (!id && body.classList.contains('navbar-open')) {
      body.classList.remove('navbar-open')
    }
  }

  isPageListing () {
    if (typeof window !== 'undefined') {
      const currPath = document.location.pathname.replace('/', '')
      return ExplorePaths.indexOf(currPath) !== -1
    }
    return false
  }

  handleClickOutside(event) {
    if (this.wrapperRef && (!this.wrapperRef.contains(event.target) || this.excludedWrapperRefContains(event.target)) &&
      !(event.target && event.target.dataset.stopProgation) && this.currentActive) {
      // toggle navigation off
      dispatcher.emit(Constants.Navigations.TOGGLE_NAV, { id: this.currentActive })
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  setExcludedWrapperRef(node) {
    if (this.excludedWrapperRef) {
      this.excludedWrapperRef.push(node)
    } else {
      this.excludedWrapperRef = [node]
    }
  }

  excludedWrapperRefContains(target) {
    let result = false
    if (this.excludedWrapperRef) {
      result = this.excludedWrapperRef.some(singleExcludeNode => singleExcludeNode.contains(target))
    }

    return result
  }

  menubarClick() {
    dispatcher.emit(Constants.Navigations.TOGGLE_NAV, { id: 'primary' })
  }

  profileItem = () => {
    return (
      <ProfileItem
        imgAlt="Aysha Anggraini"
        imgSrc="https://lh3.googleusercontent.com/-XdUIqdMkCWA/AAAAAAAAAAI/AAAAAAAAAAA/4252rscbv5M/photo.jpg?sz=215"
        username="Aysha Anggraini" />
    )
  }

  firebaseLogin = () => {
    return <User />
  }

  render() {
    const { darkmode, locale } = this.props
    const langPrefix = (this.lang !== Constants.DefaultLang ? `/${this.lang}` : '')

    const searchLink = <SearchLink path={`${langPrefix}/search`} linkClass="navbar-link" iconClass="icon-search" />
    const search = isMobile() ? searchLink : <NavInlineSearch />

    return (
      <nav className="navbar" id="navbar" ref={this.setWrapperRef}>
        <div className="container">
          <ul className="navbar-end right">
            <li className="nav-item-icon nav-item-search" ref={this.setExcludedWrapperRef}>
              { search }
            </li>
            <li className="nav-item-icon">
              <a href="javascript:;" className="btn-darkmode navbar-link" title={locale.buttons.nightMode} onClick={toggleDarkModeAndRender}>
                <span className="darkmode-image-placeholder"></span>
              </a>
            </li>
            {this.firebaseLogin()}
          </ul>
          <ul className="navbar-start">
            <li className="navbar-menu nav-item-icon">
              <a href="javascript:;" className="navbar-link" onClick={this.menubarClick}>
                <i className="icon-menu"></i>
              </a>
            </li>
            <li className="navbar-logo navbar-with-dropdown" ref={this.setExcludedWrapperRef}>
              <LogoItem darkmode={darkmode} />
            </li>
            <DropDownNav component={PrimaryDropDown} id='primary' dropdown='primary' />
          </ul>
        </div>
      </nav>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./assets/js/components/navigations/Navigation.jsx